import { render, staticRenderFns } from "./RescuerLayout.vue?vue&type=template&id=b822169a&scoped=true"
import script from "./RescuerLayout.vue?vue&type=script&lang=js"
export * from "./RescuerLayout.vue?vue&type=script&lang=js"
import style0 from "./RescuerLayout.vue?vue&type=style&index=0&id=b822169a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b822169a",
  null
  
)

export default component.exports